import { Stack, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

interface Props {
    prospectId: string;
    prospectName: string;
    customFileNumber?: string | null;
}

export default function ProspectCellLink({ prospectId, prospectName, customFileNumber }: Props) {
    const hasFileNumber = !!customFileNumber?.trim();

    return (
        <Stack spacing={0.25}>
            <Link style={{ fontWeight: 500 }} to={`/prospects/${prospectId}/summary`}>
                {hasFileNumber ? customFileNumber : prospectName}
            </Link>
            {hasFileNumber ? (
                <Typography variant="caption" color="text.secondary" component="span">
                    {prospectName}
                </Typography>
            ) : null}
        </Stack>
    );
}
